import React from "react";
import img from "../../img_project/webp/23Architecture textile modulaire avec toiles tendues et structure métallique – design contemporain et ombrage extérieur.webp"; // 🔴 adapte ton image
import img2 from ".././../img_project/webp/project6/2.webp";
import img3 from ".././../img_project/webp/project6/3.webp";
import img4 from ".././../img_project/webp/project6/4.webp";
import img1 from ".././../img_project/webp/project6/1.webp";



const Block = ({ title, children }) => (
  <section className="pj-block">
    <h2>{title}</h2>
    <div className="pj-block-content">{children}</div>
  </section>
);

export default function ProjectOFPPTGuelmim() {
  return (
    <div className="pj-page">

      {/* HERO */}
      <section className="pj-hero">
        <div className="pj-hero-text">
          <span className="pj-badge">PROJET RÉFÉRENCE</span>
          <h1>École OFPPT Guelmim <br/> Structures métallo-textiles</h1>

          <p>
            Réalisation d’une structure d’ombrage architecturale pour
            l’École OFPPT de Guelmim, combinant design contemporain,
            performance climatique et durabilité.
          </p>

          <p className="pj-sub">
            Solutions UNIK SYSTEM : Structures métallo-textiles,
            ombrage extérieur, architecture textile.
          </p>

          <div className="pj-hero-actions">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-projet-ofppt-guelmim.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche projet
            </a>
          </div>
        </div>

        <div className="pj-hero-img">
          <img src={img} alt="École OFPPT Guelmim" />
        </div>
      </section>

      {/* CONTEXTE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Contexte du projet</span>}>
        <p>
          Dans le cadre de l’aménagement des espaces extérieurs de l’École
          OFPPT de Guelmim, UNIK SYSTEM a conçu et installé des structures
          métallo-textiles destinées à créer des zones d’ombrage modernes
          et fonctionnelles.
        </p>
        <p>
          L’objectif était d’améliorer le confort des usagers tout en
          apportant une signature architecturale forte et durable,
          adaptée aux conditions climatiques locales.
        </p>
      </Block>

      {/* SOLUTIONS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Solutions UNIK SYSTEM</span>}>
        <ul className="pj-list">
          <li>Structures métallo-textiles sur mesure</li>
          <li>Voiles d’ombrage architecturales</li>
          <li>Ossature métallique haute résistance</li>
          <li>Membranes textiles techniques</li>
          <li>Protection solaire extérieure</li>
          <li>Intégration architecturale soignée</li>
        </ul>
      </Block>

      {/* RESULTATS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Résultats obtenus</span>}>
        <ul className="pj-list">
          <li>Zones d’ombre confortables pour les usagers</li>
          <li>Valorisation architecturale du site</li>
          <li>Excellente résistance aux conditions climatiques</li>
          <li>Esthétique moderne et légère</li>
          <li>Solution durable et performante</li>
        </ul>
      </Block>

      {/* GALERIE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Galerie projet</span>}>
        <div className="pj-gallery">
          <img src={img} alt="" />
          <img src={img1} alt="" />
          <img src={img2} alt="" />
          <img src={img3} alt="" />
          <img src={img4} alt="" />
        </div>
      </Block>

      {/* CTA */}
      <section className="pj-cta">
        <h2>Vous avez un projet similaire ?</h2>
        <p>
          Notre équipe technique vous accompagne de la conception à la pose.
        </p>
        <br />
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
